module.exports = __webpack_public_path__ + "static/media/icon-trapezoid-plus.3e9998bc.svg";